import SpecsGrid from "./SpecsGrid";
export default SpecsGrid;
